/**
 * Select — Dropdown dark theme com placeholder e style customizado
 */
import type { JSX } from 'preact';
import { T, CT } from '../../styles/tokens';

interface SelectProps {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
  disabled?: boolean;
  style?: JSX.CSSProperties;
  placeholder?: string;
}

export function Select({ label, value, onChange, options, disabled, style, placeholder }: SelectProps) {
  return (
    <div>
      {label && (
        <label style={{ display: 'block', fontSize: T.textSm, fontWeight: T.weightSemibold, color: T.textSecondary, marginBottom: 6 }}>
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={(e: any) => onChange(e.target.value)}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '10px 12px',
          fontSize: CT.input.fontSize,
          color: CT.input.text,
          background: CT.input.bg,
          border: `1px solid ${CT.input.border}`,
          borderRadius: CT.input.radius,
          outline: 'none',
          opacity: disabled ? 0.5 : 1,
          boxSizing: 'border-box' as any,
          ...style,
        }}
      >
        {placeholder && (
          <option value="" disabled style={{ background: T.bg, color: T.textMuted }}>
            {placeholder}
          </option>
        )}
        {options.map(o => (
          <option key={o.value} value={o.value} style={{ background: T.bg, color: T.text }}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
